import i18n from './config';

export type AppLocale = 'en' | 'ru';

export function normalizeAppLocale(value: unknown): AppLocale {
  const locale = String(value ?? '').trim().toLowerCase();
  return locale.startsWith('ru') ? 'ru' : 'en';
}

export function getIntlLocale(value?: string): string {
  return normalizeAppLocale(value ?? i18n.resolvedLanguage ?? i18n.language) === 'ru'
    ? 'ru-RU'
    : 'en-US';
}

export function formatLocaleNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(getIntlLocale(), options).format(value);
}
